"use client";

import React, { useEffect, useState } from "react"; 

const ControlPanel = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  
  const handleToggleControlPanel = () => {
    setIsDarkMode(!isDarkMode);
  };

  useEffect(() => {
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
    // Update the class on the <html> element to apply the selected mode
    const htmlElement = document.querySelector("html");
    if (isDarkMode) {
      htmlElement.classList.add("dark");
    } else {
      htmlElement.classList.remove("dark");
    }    
  }, [isDarkMode]);

  return (
    <div className="btn btn-circle btn-sm">
      <button
        variant="primary"
        className="btn bg-transparent p-0 border-0" 
        onClick={handleToggleControlPanel}
        title="Day/Night Toggle"
      >
        <i className="material-symbols-outlined text-24">
          {isDarkMode ? "dark_mode" : "light_mode"}
        </i>
      </button>

      <div>
        <div className="btn-full-close" onClick={handleToggleControlPanel}></div>
      </div>
    </div>
  );
};

export default ControlPanel;
